import React, { Suspense, lazy } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
// import Loadable from 'react-loadable'
import Loader from 'components/LayoutComponents/Loader'
import IndexLayout from 'layouts'
import NotFoundPage from 'pages/404'
import { connect, history as historyListner } from './redux/index'
import { analytics } from './services/index'
import { isDevApi } from './utils'

// Initialize google analytics page view tracking
historyListner.listen((location) => {
  const path = `${location.pathname}${location.search}`
  analytics.pageView(path)
})

// const loadable = (loader) =>
//   lazy({
//     loader,
//     delay: false,
//     loading: () => <Loader />,
//   })

const routes = [
  //  SuperAdmin Routes
  // System Pages

  {
    path: '/admin/reports',
    component: lazy(() => import('pages/user/PrivacyPolicy')),
    exact: true,
  },
  {
    path: '/user/pp',
    component: lazy(() => import('pages/user/PrivacyPolicy')),
    exact: true,
  },
  {
    path: '/user/login',
    component: lazy(() => import('pages/user/login')),
    exact: true,
  },
  {
    path: '/user/forgot',
    component: lazy(() => import('pages/user/forgot')),
    exact: true,
  },
]

const clinicRoutes = [
  {
    path: '/user/forgot',
    component: lazy(() => import('pages/user/forgot')),
    exact: true,
  },
  {
    path: '/user/login',
    component: lazy(() => import('pages/user/login')),
    exact: true,
  },
  {
    path: '*',
    component: lazy(() => import('pages/notAllowed')),
    exact: true,
  },
]

const memberRoute = [
  {
    path: '/user/forgot',
    component: lazy(() => import('pages/user/forgot')),
    exact: true,
  },
  {
    path: '/user/login',
    component: lazy(() => import('pages/user/login')),
    exact: true,
  },
  {
    path: '*',
    component: lazy(() => import('pages/notAllowed')),
    exact: true,
  },
]

const superAdminRoute = [
  {
    path: '/dashboard',
    component: lazy(() => import('pages/clinic/manage')),
    exact: true,
  },
  {
    path: '/facility/manage',
    component: lazy(() => import('pages/clinic/manage')),
    exact: true,
  },
  {
    path: '/facility/add',
    component: lazy(() => import('pages/clinic/add')),
    exact: true,
  },
  {
    path: '/facility/edit/:slug',
    component: lazy(() => import('pages/clinic/add')),
    exact: true,
  },
  {
    path: '/facility/settings/:slug',
    component: lazy(() => import('pages/clinic/settings')),
    exact: true,
  },
  {
    path: '/facility/profile/:slug',
    component: lazy(() => import('pages/clinic/profile')),
    exact: true,
  },
  {
    path: '/users/add',
    component: lazy(() => import('pages/user/add')),
    exact: true,
  },
  {
    path: '/users/profile/:slug',
    component: lazy(() => import('pages/user/profile')),
    exact: true,
  },
  {
    path: '/users/edit/:slug',
    component: lazy(() => import('pages/user/add')),
    exact: true,
  },
  {
    path: '/user/forgot',
    component: lazy(() => import('pages/user/forgot')),
    exact: true,
  },
  {
    path: '/user/login',
    component: lazy(() => import('pages/user/login')),
    exact: true,
  },
  {
    path: '/users/manage',
    component: lazy(() => import('pages/user/manage')),
    exact: true,
  },
  {
    path: '/devices/manage',
    component: lazy(() => import('pages/device/manage')),
    exact: true,
  },
  {
    path: '/group/manage',
    component: lazy(() => import('pages/group/manage')),
    exact: true,
  },
  {
    path: '/group/add',
    component: lazy(() => import('pages/group/add')),
    exact: true,
  },
  {
    path: '/group/edit/:slug',
    component: lazy(() => import('pages/group/edit')),
    exact: true,
  },
]
@connect(({ user }) => ({ user }))
class Router extends React.Component {
  getRoutes = (role, isSA) => {
    if (role === 'Superadmin' || isSA) {
      let arr = superAdminRoute
      if (isDevApi()) {
        const devBlocked = ['/users/add']
        arr = arr.filter((item) => !devBlocked.includes(item.path))
      }
      return arr
    }
    if (role === 'Provider') {
      return memberRoute
    }
    if (role === 'Clinic') {
      return clinicRoutes
    }
    if (role === 'Member') {
      return memberRoute
    }

    return routes
  }

  render() {
    const { history } = this.props // { history, user }
    const { user } = this.props
    const { role, isSA } = user
    const RoutesList = this.getRoutes(role, isSA)

    return (
      <ConnectedRouter history={history}>
        <IndexLayout>
          <Switch>
            {role === 'Superadmin' || isSA ? (
              <Route
                exact
                path="/"
                key="defaultRoute"
                render={() => (
                  <Suspense fallback={<Loader />}>
                    <Redirect to="/dashboard" />
                  </Suspense>
                )}
              />
            ) : (
              <Route
                exact
                path="/"
                key="defaultRoute"
                render={() => (
                  <Suspense fallback={<Loader />}>
                    <Redirect to="/clinic/profile" />
                  </Suspense>
                )}
              />
            )}

            {RoutesList.map((route) => (
              <Route
                path={route.path}
                render={(props) => (
                  <Suspense fallback={<Loader />}>
                    <route.component {...route.customProps} {...props} />
                  </Suspense>
                )}
                key={route.path}
                customProps={route.customProps}
                exact={route.exact}
              />
            ))}
            <Route
              render={(props) => (
                <Suspense fallback={<Loader />}>
                  <NotFoundPage {...props} type="Clinic" />{' '}
                </Suspense>
              )}
              path="/clinic/NotFound"
            />
            <Suspense fallback={<Loader />}>
              <Route component={NotFoundPage} />/
            </Suspense>
          </Switch>
        </IndexLayout>
      </ConnectedRouter>
    )
  }
}

export default Router
